import Details from './details'
import Update from './update'

export default {
  details: Details,
  update: Update
}
